var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWaveTriangle = function SvgIconWaveTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.125 4.25a1 1 0 0 1 .81.415l8.94 12.377 4.064-5.628a1 1 0 0 1 1.622 1.172l-4.875 6.75a1 1 0 0 1-1.622 0L7.125 6.958l-4.064 5.627a1 1 0 0 1-1.622-1.17l4.875-6.75a1 1 0 0 1 .811-.415",
    clipRule: "evenodd"
  })));
};
export default SvgIconWaveTriangle;